import React from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import WishListSection from "../components/WishListSection";
import Footer from "../components/Footer";
import NewsletterTwo from "../components/NewsletterTwo";

function WishlistPage() {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='var(--brand-primary)' />

      {/* Preloader */}
      <Preloader />

      {/* Header */}
      <HeaderThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"My Wishlist"} />

      {/* WishListSection */}
      <WishListSection />

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* Footer */}
      <Footer />
    </>
  );
}

export default WishlistPage;
